import { Component, OnInit } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { take } from 'rxjs/operators';
import { DataSharingService } from '../shared/services/data-sharing.service';
import {
  clearAuthStateForRelogin,
  consumeForbiddenReturnUrl,
  peekForbiddenReturnUrl,
} from '../shared/services/token.util';

@Component({
    selector: 'app-forbidden',
    templateUrl: './forbidden.component.html',
    styleUrls: ['./forbidden.component.scss'],
    standalone: false
})
export class ForbiddenComponent implements OnInit {
  userName = '';
  userEmail = '';
  userRole = '';
  returnUrl = '/';

  constructor(
    public auth: AuthService,
    private dataSharingService: DataSharingService
  ) {}

  ngOnInit(): void {
    this.returnUrl = peekForbiddenReturnUrl('/');

    this.userRole =
      this.dataSharingService.clientRole ||
      localStorage.getItem('role') ||
      '';
    this.userName = this.dataSharingService.clientName || '';
    this.userEmail = this.dataSharingService.clientEmail || '';

    this.auth.user$.pipe(take(1)).subscribe((user) => {
      if (!this.userEmail) {
        this.userEmail = user?.email || '';
      }
      if (!this.userName) {
        this.userName =
          user?.name || user?.nickname || user?.email || '';
      }
    });
  }

  login(): void {
    const target = consumeForbiddenReturnUrl(this.returnUrl || '/');
    clearAuthStateForRelogin();

    this.auth.loginWithRedirect({
      authorizationParams: {
        prompt: 'login',
      },
      appState: { target },
    });
  }
}
